export default "__VITE_ASSET__DijpzB08__"